import { today } from '@squadcore/api/shared/time'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { homeScope } from '~/features/home/queries'
import { MePage } from '~/features/self/MePage'
import { overviewRange } from '~/features/self/search'
import { meQuery, selfAllowed, myAbsencesQuery, myDocumentsQuery, mySessionsQuery, myStatsQuery } from '~/features/self/queries'

export const Route = createFileRoute('/_app/ich/')({
  beforeLoad: async ({ context }) => {
    if (!(await selfAllowed(context.queryClient))) throw redirect({ to: '/' })
  },
  loader: async ({ context }) => {
    const scope = await homeScope(context.queryClient)
    if (!scope) return
    const qc = context.queryClient
    const { from, to } = overviewRange(today(scope.timezone))
    // One wave: every block of the page in parallel, none waits for another.
    await Promise.all([
      qc.ensureQueryData(meQuery(scope.teamId, scope.season)),
      qc.ensureQueryData(mySessionsQuery(scope.teamId, scope.season, from, to)),
      qc.ensureQueryData(myAbsencesQuery(scope.teamId, scope.season)),
      qc.ensureQueryData(myStatsQuery(scope.teamId, scope.season)),
      qc.ensureQueryData(myDocumentsQuery(scope.teamId, scope.season)),
    ]).catch(() => undefined)
  },
  component: MePage,
})
